import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NavSet from './nav-set';

class NavigationBottom extends Component {
  constructor() {
    super(...arguments);
  }
  render() {
    const props = this.props;
    return (
      <nav
        className='nav-bottom'>
        <div className='application-header-container'>
          <NavSet
            { ...props }
          />
        </div>
      </nav>
    );
  }
}

/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */

const rightNavPropTypes = PropTypes.shape({
  'blacklist': PropTypes.object,
  'whitelist': PropTypes.object,
  'caption': PropTypes.node,
  'data-mix': PropTypes.string,
  'disposition': PropTypes.string,
  'eid': PropTypes.string,
  'href': PropTypes.string,
  'children': PropTypes.array,
  'design': PropTypes.oneOf(['purchase', 'primary', 'default'])
});

NavigationBottom.propTypes = {
  navigation: PropTypes.array.isRequired,
  navigationRight: PropTypes.arrayOf(rightNavPropTypes)
};

export default NavigationBottom;
